import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import 'font-awesome/css/font-awesome.min.css'
import './assets/css/iconfont/iconfont.css'
import './assets/css/custom-element-ui.less'
import VueResource from 'vue-resource'
import VueLogger from 'vuejs-logger'
import store from './store/store'
import http from './common/utils/http'
import 'vant/lib/index.css';

import DateUtils from './common/utils/date-util'
// import './static/icons'
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.prototype.utils = {
  DateUtils: DateUtils
}

Vue.use(ElementUI)
Vue.use(VueResource)

const options = {
  // optional : defaults to true if not specified
  isEnabled: true,
  // required ['debug', 'info', 'warn', 'error', 'fatal']
  logLevel: 'debug',
  // optional : defaults to false if not specified
  stringifyArguments: false,
  // optional : defaults to false if not specified
  showLogLevel: false,
  // optional : defaults to false if not specified
  showMethodName: true,
  // optional : defaults to '|' if not specified
  separator: '|',
  // optional : defaults to false if not specified
  showConsoleColors: true
}

Vue.use(VueLogger, options)
// 全局mock开关 false关，true开
const mock = true
if (mock) {
  require('./mock')
}
http.interceptors.request.use(
  config => {
    if (localStorage.getItem('token')) {
      // console.log(`sessionStorage: ${sessionStorage.getItem('token')}`)
      config.headers['X-Authorization'] = localStorage.getItem('token')
    }
    // else {
    //   window.location.href = '/#/'
    // }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
http.interceptors.response.use(
  response => {
    if (response.data.code === '403') {
      // window.location.href = 'localhost:8080/login'
      return null
    } else {
      return response
    }
  },
  error => {
    const response = error.response
    if (response.status === 400 && response.data.code && response.data.code.includes('_BAFERRMSG_')) {
      Message.error(response.data.message)
      return response
    }
    return Promise.reject(error.response)
  }
)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js